<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Comisiones</h3>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <ComisionUtilidad
          :comisionesUtilidades="form.comisiones_utilidades"
          :erroresComisionesUtilidades="errores.comisiones_utilidades"
        />
        <ComisionVenta
          :comisionesVentas="form.comisiones_ventas"
          :erroresComisionesVentas="errores.comisiones_ventas"
          :optionsCategorias="options_categorias"
        />
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button @click="botonGuardar()" class="btn-success" type="button">
              <i class="fa fa-save"></i><span>Guardar</span>
            </button>
            <button @click="botonLimpiar()" class="btn-light btn--text" type="button">
              <i class="fa fa-plus"></i><span>Nuevo</span>
            </button>
            <button @click="botonCerrar()" class="btn-danger" type="button">
              <i class="fa fa-times"></i><span>Cerrar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options_categorias: [],
      form: {
        comisiones_ventas: [],
        comisiones_utilidades: [],
      },
      errores: {
        comisiones_ventas: [],
        comisiones_utilidades: [],
      },
    };
  },
  mounted() {
    axios.get(url + "parametros/cargar-comisiones").then(response => {
      let data = response.data;
      this.options_categorias.splice(0, this.options_categorias.length, ...data.categorias);
      this.form.comisiones_ventas.splice(0, this.form.comisiones_ventas.length, ...data.comisiones_ventas);
      this.form.comisiones_utilidades.splice(0, this.form.comisiones_utilidades.length, ...data.comisiones_utilidades);
      for (let i = 0; i < this.form.comisiones_ventas.length; i++) {
        this.errores.comisiones_ventas.push({
          nombre: null,
          porcentaje: null,
          categoria_ids: null,
        });
      }
      for (let i = 0; i < this.form.comisiones_utilidades.length; i++) {
        this.errores.comisiones_utilidades.push({
          nombre: null,
          porcentaje: null,
          valor_desde: null,
          valor_hasta: null,
        });
      }
    });
  },
  methods: {
    limpiarCampos: function () {
      this.form.comisiones_ventas.splice(0, this.form.comisiones_ventas.length);
      this.form.comisiones_utilidades.splice(0, this.form.comisiones_utilidades.length);
      this.errores.comisiones_ventas.splice(0, this.errores.comisiones_ventas.length);
      this.errores.comisiones_utilidades.splice(0, this.errores.comisiones_utilidades.length);
    },
    botonLimpiar: function () {
      swal.fire({
        title: "¿Desea limpiar las comisiones?",
        text: "Se requiere confirmación",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          this.limpiarCampos();
        }
      });
    },
    validaciones: function () {
        let error = false;
        this.form.comisiones_utilidades.forEach((comision, key) => {
          this.errores.comisiones_utilidades[key].nombre = null;
          this.errores.comisiones_utilidades[key].porcentaje = null;
          this.errores.comisiones_utilidades[key].valor_desde = null;
          this.errores.comisiones_utilidades[key].valor_hasta = null;
          if (comision.nombre == '') {
            this.errores.comisiones_utilidades[key].nombre = "El campo es requerido.";
            error = true;
          }
          if (comision.porcentaje == '' || parseFloat(comision.porcentaje) <= 0) {
            this.errores.comisiones_utilidades[key].porcentaje = "El campo es requerido.";
            error = true;
          }
          if (comision.valor_desde == '' || parseFloat(comision.valor_desde) <= 0) {
            this.errores.comisiones_utilidades[key].valor_desde = "El campo es requerido.";
            error = true;
          }
          if (comision.valor_hasta == '' || parseFloat(comision.valor_hasta) <= 0) {
            this.errores.comisiones_utilidades[key].valor_hasta = "El campo es requerido.";
            error = true;
          }
          if(parseFloat(comision.valor_desde) >= parseFloat(comision.valor_hasta)){
            this.errores.comisiones_utilidades[key].valor_desde = "El campo no puede ser mayor o igual al campo 'Hasta'.";
            error = true;
          }
          else {
            this.form.comisiones_utilidades.forEach((comision2, key2) => {
              if (key != key2) {
                if (parseFloat(comision.valor_desde) >= parseFloat(comision2.valor_desde) && parseFloat(comision.valor_desde) <= parseFloat(comision2.valor_hasta)) {
                  this.errores.comisiones_utilidades[key].valor_desde = "No se puede repetir el rango.";
                  swal.fire("Aviso", `No se puede repetir el rango.`, "warning");
                  error = true;
                  return error;
                }
                if (parseFloat(comision.valor_hasta) >= parseFloat(comision2.valor_desde) && parseFloat(comision.valor_hasta) <= parseFloat(comision2.valor_hasta)) {
                  this.errores.comisiones_utilidades[key].valor_hasta = "No se puede repetir el rango.";
                  swal.fire("Aviso", `No se puede repetir el rango.`, "warning");
                  error = true;
                  return error;
                }
              }
            });
          }
        });
        this.form.comisiones_ventas.forEach((comision, key) => {
          this.errores.comisiones_ventas[key].nombre = null;
          this.errores.comisiones_ventas[key].porcentaje = null;
          this.errores.comisiones_ventas[key].categoria_ids = null;
          this.errores.comisiones_ventas[key].valor_desde = null;
          this.errores.comisiones_ventas[key].valor_hasta = null;
          if (comision.nombre == '') {
            this.errores.comisiones_ventas[key].nombre = "El campo es requerido.";
            error = true;
          }
          if (comision.porcentaje == '' || parseFloat(comision.porcentaje) <= 0) {
            this.errores.comisiones_ventas[key].porcentaje = "El campo es requerido.";
            error = true;
          }
          if (comision.categoria_ids.length == 0) {
            this.errores.comisiones_ventas[key].categoria_ids = "El campo es requerido.";
            error = true;
          }
          if (comision.valor_desde == '' || parseFloat(comision.valor_desde) <= 0) {
            this.errores.comisiones_ventas[key].valor_desde = "El campo es requerido.";
            error = true;
          }
          if (comision.valor_hasta == '' || parseFloat(comision.valor_hasta) <= 0) {
            this.errores.comisiones_ventas[key].valor_hasta = "El campo es requerido.";
            error = true;
          }
          if(parseFloat(comision.valor_desde) >= parseFloat(comision.valor_hasta)){
            this.errores.comisiones_ventas[key].valor_desde = "El campo no puede ser mayor o igual al campo 'Hasta'.";
            error = true;
          }
          else {
            this.form.comisiones_ventas.forEach((comision2, key2) => {
              if (key != key2) {
                comision.categoria_ids.forEach(categoria => {
                  if (comision2.categoria_ids.includes(categoria)) {
                    this.errores.comisiones_ventas[key].categoria_ids = "No se puede repetir la categoría.";
                    swal.fire("Aviso", `No se puede repetir la categoría.`, "warning");
                    error = true;
                    return error;
                  }
                });
                if (parseFloat(comision.valor_desde) >= parseFloat(comision2.valor_desde) && parseFloat(comision.valor_desde) <= parseFloat(comision2.valor_hasta)) {
                  this.errores.comisiones_ventas[key].valor_desde = "No se puede repetir el rango.";
                  swal.fire("Aviso", `No se puede repetir el rango.`, "warning");
                  error = true;
                  return error;
                }
                if (parseFloat(comision.valor_hasta) >= parseFloat(comision2.valor_desde) && parseFloat(comision.valor_hasta) <= parseFloat(comision2.valor_hasta)) {
                  this.errores.comisiones_ventas[key].valor_hasta = "No se puede repetir el rango.";
                  swal.fire("Aviso", `No se puede repetir el rango.`, "warning");
                  error = true;
                  return error;
                }
              }
            });
          }
      });
      return error;
    },
    botonGuardar: function () {
      if (this.validaciones())
        return;
      swal.fire({
        title: "¿Estas seguro de guardar las comisiones?",
        text: "Se requiere confirmación",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          axios.post(url + "parametros/guardar-comisiones", this.form).then(response => {
          swal.fire("¡Guardado!", "Los datos han sido almacenados.", "success");
          this.$modal.hide("comisiones");
          }).then(error => {
            if (error !== undefined && error !== null) {
              let response = error.response;
              if (response !== undefined && response !== null) {
                if (response.status === 422) {
                  that.errores = response.data.errors;
                  swal("Verifique los datos ingresados, ya que tienen errores.", "Error", "warning");
                }
                else
                  swal("Hubo un error al momento de almacenar los datos.", "Intente nuevamente.", "error");
              }
            }
          });
        }
      });
    },
    botonCerrar: function(){
      swal.fire({
        title: "¿Desea cerrar las comisiones?",
        text: "Se requiere confirmación",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          this.$modal.hide("comisiones");
        }
      });
    }
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/parametrizacion/comisiones/Comisiones.vue